import React, { useState } from 'react';
import { Button } from './ui/Button';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
export function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    state: '',
    phone: '',
    email: '',
    comments: '',
    hearAboutUs: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
  };
  return <section className="py-16 md:py-24 bg-white" data-id="element-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-19">
            Contact Peak Machine Sales
          </h2>
          <p className="text-lg text-gray-600" data-id="element-20">
            Tell us what you're looking for and our team will respond.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12" data-id="element-21">
          {/* Form */}
          <div data-id="element-22">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-23">
              <div data-id="element-24">
                <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-25">
                  Name *
                </label>
                <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-26" />
              </div>

              <div data-id="element-27">
                <label htmlFor="company" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-28">
                  Company *
                </label>
                <input type="text" id="company" name="company" required value={formData.company} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-29" />
              </div>

              <div className="grid sm:grid-cols-2 gap-6" data-id="element-30">
                <div data-id="element-31">
                  <label htmlFor="state" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-32">
                    State *
                  </label>
                  <input type="text" id="state" name="state" required value={formData.state} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-33" />
                </div>

                <div data-id="element-34">
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-35">
                    Phone *
                  </label>
                  <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-36" />
                </div>
              </div>

              <div data-id="element-37">
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-38">
                  Email *
                </label>
                <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-39" />
              </div>

              <div data-id="element-40">
                <label htmlFor="comments" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-41">
                  Comments
                </label>
                <textarea id="comments" name="comments" rows={4} value={formData.comments} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all resize-none" data-id="element-42" />
              </div>

              <div data-id="element-43">
                <label htmlFor="hearAboutUs" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-44">
                  How Did You Hear About Us?
                </label>
                <select id="hearAboutUs" name="hearAboutUs" value={formData.hearAboutUs} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange focus:border-transparent transition-all" data-id="element-45">
                  <option value="" data-id="element-46">Pick One</option>
                  <option value="advertisement" data-id="element-47">Advertisement</option>
                  <option value="competitor" data-id="element-48">Competitor</option>
                  <option value="customer-referral" data-id="element-49">
                    Existing Customer Referral
                  </option>
                  <option value="search-engine" data-id="element-50">Search Engine</option>
                  <option value="social-media" data-id="element-51">Social Media</option>
                  <option value="trade-show" data-id="element-52">Trade Show</option>
                  <option value="other" data-id="element-53">Other</option>
                </select>
              </div>

              {/* reCAPTCHA Placeholder */}
              <div className="bg-gray-100 border border-gray-300 rounded-md p-4 flex items-center justify-center" data-id="element-54">
                <span className="text-gray-500 text-sm" data-id="element-55">
                  reCAPTCHA Placeholder
                </span>
              </div>

              <Button type="submit" variant="primary" size="lg" className="w-full" data-id="element-56">
                Submit
              </Button>
            </form>
          </div>

          {/* Contact Details */}
          <div className="lg:pl-8" data-id="element-57">
            <div className="bg-gray-50 rounded-lg p-8 border border-gray-200" data-id="element-58">
              <h3 className="text-2xl font-bold text-navy mb-6" data-id="element-59">
                Get In Touch
              </h3>

              <div className="space-y-6" data-id="element-60">
                <div className="flex items-start" data-id="element-61">
                  <MapPinIcon className="w-6 h-6 text-orange mr-4 flex-shrink-0 mt-1" data-id="element-62" />
                  <div data-id="element-63">
                    <p className="font-semibold text-gray-900 mb-1" data-id="element-64">Address</p>
                    <p className="text-gray-700" data-id="element-65">
                      28221 Beck Road, Unit A2
                      <br data-id="element-66" />
                      Wixom, Michigan 48393
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-67">
                  <PhoneIcon className="w-6 h-6 text-orange mr-4 flex-shrink-0 mt-1" data-id="element-68" />
                  <div data-id="element-69">
                    <p className="font-semibold text-gray-900 mb-1" data-id="element-70">Phone</p>
                    <a href="tel:2483800871" className="text-blue hover:text-orange transition-colors font-medium text-lg" data-id="element-71">
                      (248) 380-0871
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-300" data-id="element-72">
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-73">
                  Our team is ready to help you find the right CNC machine tools
                  for your manufacturing needs. We typically respond within 24
                  hours.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}